import { render, staticRenderFns } from "./AjusteInventarioFormComponent.vue?vue&type=template&id=47a8ed16&"
import script from "./AjusteInventarioFormComponent.vue?vue&type=script&lang=js&"
export * from "./AjusteInventarioFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports